import axios from 'axios';

type Props = {
    id: string;
    rotaryCd: string;
}

/**
 * イベントへ参加予定の会員情報を取得するAPI
 */
export async function getLoginName({id, rotaryCd}: Props){
    const response = await axios.get(process.env.REACT_APP_PATH + `/users/me/account/accountinfo`, {
        params: {
            rotaryCd: rotaryCd,
            paramId: id
        },
        paramsSerializer:{
            indexes: null
        }

    })
    return JSON.parse(JSON.stringify(response.data[0]))
}